export const jobAlerts = [
    {
      company: 'Google',
      role: 'Software Engineer',
      deadline: '2025-06-13',
      type: 'Full-time',
      link: 'https://www.google.com/about/careers/applications/jobs/results#!t=jo&jid=127025001&',
    },
    {
      company: 'Microsoft',
      role: 'SDE Intern',
      deadline: '2026-16-25',
      type: 'Internship',
      link: 'https://apply.careers.microsoft.com/careers?start=0&pid=1970393556747930&sort_by=timestamp',
    },
    {
      company: 'Amazon',
      role: 'Backend Developer',
      deadline: '2025-05-27',
      type: 'Full-time',
      link: 'https://www.amazon.jobs/en/jobs/3136647/database-engineer-ii-fintech',
    },
    {
      company: 'Josh Technology Group',
      role: 'Senior Software Developer I (.NET)',
      deadline: 'Open',
      type: 'Full-time',
      link: 'https://www.joshtechnologygroup.com/careers/senior-software-developer-i-net/',
    }
  ];
